class CartDrawerRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    // Only load if cart has items
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;
    
    // Wait for cart drawer to be ready
    if (this.dataset.productId) {
      this.initializeRecommendations(this.dataset.productId);
    } else {
      // Try to get product ID from cart items
      this.waitForCartItems();
    }
  }

  waitForCartItems() {
    // Check if cart items are loaded
    const cartItems = document.querySelector('cart-drawer-items');
    if (cartItems) {
      // Try to fetch cart data to get product ID
      fetch(`${window.routes.cart_url}.js`)
        .then(response => response.json())
        .then(cartData => {
          if (cartData.items && cartData.items.length > 0) {
            this.initializeRecommendations(cartData.items[0].product_id);
          }
        })
        .catch(() => {
          // If cart fetch fails, observe for cart updates
          this.observeCartUpdates();
        });
    } else {
      this.observeCartUpdates();
    }
  }

  observeCartUpdates() {
    // Subscribe to cart updates to get product ID when items are added
    if (typeof subscribe === 'function') {
      subscribe('cart:update', () => {
        fetch(`${window.routes.cart_url}.js`)
          .then(response => response.json())
          .then(cartData => {
            if (cartData.items && cartData.items.length > 0 && !this.dataset.productId) {
              this.dataset.productId = cartData.items[0].product_id;
              this.initializeRecommendations(cartData.items[0].product_id);
            }
          });
      });
    }
  }

  initializeRecommendations(productId) {
    console.log('initializeRecommendations', productId);
    if (!productId) return;
    console.log('initializeRecommendations', productId);
    
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 200px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    const sectionId = this.dataset.sectionId || 'cart-drawer-recommendations';
    const url = `${this.dataset.url}&product_id=${productId}&section_id=${sectionId}`;
    
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        // Parse the response - Shopify returns HTML with a section wrapper
        const html = document.createElement('div');
        html.innerHTML = text;
        
        // Find the section content
        const section = html.querySelector(`[id*="${sectionId}"]`) || html.querySelector('.shopify-section');
        const recommendations = section?.querySelector('cart-drawer-recommendations') || section;

        if (recommendations?.innerHTML.trim().length) {
          // Update the grid content
          const grid = this.querySelector('.cart-drawer__recommendations-grid');
          const newGrid = recommendations.querySelector('.cart-drawer__recommendations-grid');
          
          if (grid && newGrid) {
            grid.innerHTML = newGrid.innerHTML;
          } else {
            // If grid doesn't exist, update the whole content but keep the header
            const header = this.querySelector('.cart-drawer__recommendations-header');
            const newHeader = recommendations.querySelector('.cart-drawer__recommendations-header');
            if (newHeader && header) {
              // Keep existing header, just update grid
              if (newGrid) {
                grid.innerHTML = newGrid.innerHTML;
              }
            } else {
              // Full replacement
              this.innerHTML = recommendations.innerHTML;
            }
          }
          
          // Re-initialize product forms
          this.querySelectorAll('product-form').forEach(form => {
            if (typeof form.connectedCallback === 'function') {
              form.connectedCallback();
            }
          });
        } else {
          // Hide if no recommendations
          this.style.display = 'none';
        }
      })
      .catch((e) => {
        console.error('Cart drawer recommendations error:', e);
        // Hide on error
        this.style.display = 'none';
      });
  }

  disconnectedCallback() {
    this.observer?.unobserve(this);
  }
}

customElements.define('cart-drawer-recommendations', CartDrawerRecommendations);

